/* eslint import/no-extraneous-dependencies: off */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const setAddHubServerAttribute = createAsyncThunk("addHubServerAttribute/setHubServerAttribute", async (inputData) => {
    return inputData;
});

export const initialState = {
    hub_server_info_attribute_id: "",
    hub_server_info_id: "",
    name: "",
    description: "",
    value: "",
    data_type: "",
    attribute_type: "",
    status: ""
};

const addHubServerAttributeSlice = createSlice({
    name: "addHubServerAttribute",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setAddHubServerAttribute.fulfilled, (state, action) => action.payload);
    }
});

export const selectHubServerAttribute = ({ addHubServerAttribute }) => addHubServerAttribute;

export default addHubServerAttributeSlice.reducer;
